import { Components, Theme } from '@mui/material';

export const MuiAlert: Components<Omit<Theme, 'components'>>['MuiAlert'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.primary.colorFixed,
      color: theme.palette.primary.onColorFixed,
      variants: [
        {
          props: { variant: 'messageStandard' },
          style: {
            backgroundColor: theme.palette.primary.colorFixed,
            color: theme.palette.primary.onColorFixed,
          },
        },
        {
          props: { variant: 'messageInfo' },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.secondary.colorFixed,
            color: theme.palette.secondary.onColorFixed,
          }),
        },

        {
          props: { variant: 'messageWarning' },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.tertiary.colorFixed,
            color: theme.palette.tertiary.onColorFixed,
          }),
        },
        {
          props: { variant: 'messageError' },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.onColor,
          }),
        },
      ],
    }),
  },
};
